export const createWindow = () => (typeof window === 'undefined') ? null : window;
//# sourceMappingURL=/build/es2018/factories/window.js.map